import { SESSION_KEY } from './types';
import type { KeyValueStore } from './types';

export interface SessionState {
  id: string;
  startedAt: string;
  lastActivity: number;
}

/** Reads the tab's tracking session back after a reload. Anything unreadable means "no session". */
export function loadSession(store: KeyValueStore | null): SessionState | null {
  try {
    const raw = store?.getItem(SESSION_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as Partial<SessionState>;
    if (
      typeof value.id !== 'string' ||
      typeof value.startedAt !== 'string' ||
      typeof value.lastActivity !== 'number'
    ) {
      return null;
    }
    if (Number.isNaN(Date.parse(value.startedAt))) return null;
    return { id: value.id, startedAt: value.startedAt, lastActivity: value.lastActivity };
  } catch {
    return null;
  }
}

export function saveSession(store: KeyValueStore | null, session: SessionState | null): void {
  try {
    if (session) store?.setItem(SESSION_KEY, JSON.stringify(session));
    else store?.removeItem(SESSION_KEY);
  } catch {
    // Storage blocked: the session lives in memory for this page load.
  }
}
